<div class="time-picker-overlay mat-elevation-z4">
    <input type="time" (change)="timeChanged($event)" [value]="time" [step]="minuteStep * 60" />
</div>
